import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { Button } from "react-bootstrap";
import { IoSync } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import "./component.css";

const HistoryRencanaTanam = () => {
  const { user } = useSelector((state) => state.auth);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();

  const fetchRencanaTanam = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      setMsg("Token tidak ditemukan. Silakan login ulang.");
      return;
    }

    setLoading(true);
    setMsg("");

    try {
      console.log("Fetching data from API...");
      const response = await axios.get(
        "https://c-greenproject.org:8000/historytanam",
        {
          headers: { Authorization: `Bearer ${token}` },
          withCredentials: true,
        }
      );
      console.log("Raw Response:", response.data);

      if (Array.isArray(response.data)) {
        let formattedData = response.data.flatMap((item) =>
          item.rencanaTanamInfo ? item.rencanaTanamInfo : item
        );
        console.log("Formatted Data:", formattedData);
        setProducts(formattedData);
      } else {
        setMsg("Data tidak valid dari server.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setMsg(
        error.response?.data?.msg || "Gagal mengambil data. Coba lagi nanti."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      fetchRencanaTanam();
    }
  }, [user]);

  return (
    <div>
      <h2 className="title">
        <strong>History Rencana Tanam</strong>
      </h2>
      {msg && <p className="notification is-danger">{msg}</p>}
      <div className="detail-table-container">
        {products.length > 0 ? (
          <table className="table is-striped is-fullwidth detail-table">
            <thead>
              <tr className="text-center">
                <th>No</th>
                <th>ID Tanam</th>
                <th>Status</th>
                <th>Varietas Singkong</th>
                <th>Estimasi Produksi (kg)</th>
                <th>Tanggal Rencana Tanam</th>
                <th>Tanggal Rencana Panen</th>
              </tr>
            </thead>
            <tbody className="text-center">
              {products.map((product, index) => (
                <React.Fragment key={product.idtanam || index}>
                  <tr>
                    <td>{index + 1}</td>
                    <td>{product.idtanam}</td>
                    <td>{product.statusRencanaTanam}</td>
                    <td>{product.varietassingkong}</td>
                    <td>{product.estimasiproduksi}</td>
                    <td>{product.tanggalRencanaTanam}</td>
                    <td>{product.tanggalRencanaPanen}</td>
                  </tr>
                  <tr className="detail-row">
                    <td colSpan="8">
                      <Button
                        variant="link"
                        className="btn-sm detail-button"
                        onClick={() =>
                          navigate(`/historytanam/${product.idtanam}`)
                        }
                      >
                        Lihat Detail Rencana Tanam
                      </Button>
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="notification is-info">Tidak ada data rencana tanam.</p>
        )}
        {loading && <p className="notification is-info">Loading...</p>}
      </div>
    </div>
  );
};

export default HistoryRencanaTanam;
